import { emitEvent as g, onEvent as X, useEvent as ge, offEvent as he } from "@utsubo/events";
import { create as z } from "zustand";
import { shallow as J } from "zustand/shallow";
import { useState as Q, useEffect as T, useCallback as je } from "react";
import * as E from "three";
import { NetworkingClient as xe } from "@utsubo/networking-test";
import { suspend as qe } from "suspend-react";
import { jsx as Ce } from "react/jsx-runtime";
import { useFrame as G } from "@react-three/fiber";
import { detectDevice as ye, useStoreScene as Fe, shared as Pe } from "@utsubo/renderer";
import { getPhysic as We } from "@utsubo/oni";
import ze, { Peer as Je } from "peerjs";
const te = /* @__PURE__ */ z((e, n) => ({ peerConnsByIds: {}, connByIds: {}, reliableByIds: {}, addPeerConnsByIds: (o, r) => {
  e((t) => {
    const s = { peerConnsByIds: { ...t.peerConnsByIds } };
    return s.peerConnsByIds[o] = r, s;
  });
}, addReliableConn: (o, r) => {
  e((t) => {
    const s = { reliableByIds: { ...t.reliableByIds } };
    return s.reliableByIds[o] = r, s;
  });
}, addConn: (o, r) => {
  e((t) => {
    const s = { connByIds: { ...t.connByIds } };
    return s.connByIds[o] = r, s;
  });
}, removePeerConnsByIds: (o) => {
  e((r) => {
    const t = { peerConnsByIds: { ...r.peerConnsByIds } };
    return delete t.peerConnsByIds[o], t;
  });
}, removeReliableConn: (o) => {
  e((r) => {
    const t = { reliableByIds: { ...r.reliableByIds } };
    return delete t.reliableByIds[o], t;
  });
}, removeConn: (o) => {
  e((r) => {
    const t = { connByIds: { ...r.connByIds } };
    return delete t.connByIds[o], t;
  });
}, peer: null })), oe = (e, n) => te(e, n || J);
Object.assign(oe, te);
const { getState: V, setState: Qe } = te, re = /* @__PURE__ */ z((e, n) => {
  const o = async (t) => {
    const s = t === "video";
    e(s ? { videoAccessEnabled: true } : { audioAccessEnabled: true });
    const l = /* @__PURE__ */ localStorage.getItem(`preferred${s ? t : "mic"}`);
    let i = {}, p = await navigator.mediaDevices.getUserMedia({ [t]: l ? { deviceId: l } : true, [s ? "audio" : "video"]: false }).catch((a) => (console.error(a), i = a, null));
    return i.name === "NotFoundError" || i.name === "OverconstrainedError" ? (p = await navigator.mediaDevices.getUserMedia({ [t]: true }), null) : i.name === "NotReadableError" ? (g("notification:office", { message: (s ? "cam" : "mic") + "-not-accessible" }), null) : p[s ? "getVideoTracks" : "getAudioTracks"]()[0].getSettings().deviceId;
  }, r = async (t, s, l) => {
    const i = t === "microphone" ? { audio: true } : { video: true };
    if (n()[s]) {
      const c = await navigator.permissions.query({ name: t });
      return c.state === "granted" ? true : c.state === "prompt" ? await navigator.mediaDevices.getUserMedia(i) : (e({ [l]: false }), false);
    }
    e({ [s]: true });
    const p = await navigator.permissions.query({ name: t });
    return p.onchange = () => p.state === "granted" ? true : (e({ [l]: false }), false), p.state === "granted" ? true : p.state === "prompt" ? await navigator.mediaDevices.getUserMedia(i) : (e({ [l]: false }), false);
  };
  return { localUserId: null, playersRealtime: {}, otherPlayers: [], otherPlayersStartPos: {}, useToken: true, audioAuthListenerSet: false, videoAuthListenerSet: false, audioAuthAsked: false, videoAuthAsked: false, audioAccessEnabled: false, videoAccessEnabled: false, checkDevice: async (t) => {
    if (typeof navigator == "object") {
      let s = false, l = false;
      return t === "audio" ? l = await r("microphone", "audioAuthListenerSet", "audioAccessEnabled") : l = await r("camera", "videoAuthListenerSet", "videoAccessEnabled"), l && (s = await o(t)), s;
    }
    return null;
  }, checkAuthStatus: async () => {
    const t = {};
    try {
      t.audioAuthAsked = localStorage.getItem("auth:audio"), t.videoAuthAsked = localStorage.getItem("auth:video");
    } catch (s) {
      console.error("checkAuthStatus", s);
    }
    e(t), t.audioAuthAsked && await n().checkDevice("audio"), t.videoAuthAsked && await n().checkDevice("video");
  }, userMediaUpdate: async (t, s) => {
    try {
      t && localStorage.setItem("auth:audio", true), s && localStorage.setItem("auth:video", true);
    } catch (l) {
      console.error("userMediaUpdate", l);
    }
    await n().checkAuthStatus();
  } };
}), L = (e, n) => re(e, n || J);
Object.assign(L, re);
const { getState: P, setState: x } = re, R = [], Ge = (e) => R.find((n) => n.playerId === e), Ye = (e) => R.find((n) => n.peerId === e);
async function Xe(e) {
  e.call && e.call.open && (e.call.close(), e.call = null, e.reliableConn && e.reliableConn.send("closeCall")), Ke();
}
const Ke = () => {
  let e = false;
  for (let n = 0; n < R.length; n++)
    if (R[n].call) {
      e = true;
      break;
    }
  e || P().closeAudioStream();
};
async function Ze(e, n, o) {
  const { peerConnsByIds: r } = /* @__PURE__ */ V(), { playerId: t, getAudioStream: s } = /* @__PURE__ */ P();
  let l = await s();
  const i = r[o];
  i && (n.call = e.call(i.conn.peer, l, { metadata: { playerId: t } }), n.call && n.call.on("stream", (p) => {
    g(`stream_start_${o}`, p);
  }));
}
function I(e, n = true) {
  for (let o = 0; o < R.length; o++) {
    let r;
    if (r = R[o][n ? "reliableConn" : "conn"], !r || !r.open)
      return;
    r.send(e);
  }
}
const He = ["idle", void 0];
function ve(e, n, o) {
  const { playersRealtime: r } = /* @__PURE__ */ P();
  He.includes(n[o]) && r[e].lastAnim === n[o] || (g(`anim_${e}`, { name: n[o || 16], play: true, reset: true, blendDuration: 0.2 }), r[e].lastAnim = n[o || 16], x({ playersRealtime: r }));
}
const M = { sendCustomMessage: (e, n) => {
} }, en = async ({ roomId: e, token: n, refreshToken: o, wshost: r, localUserId: t, wsSecure: s, wsMaxPlayersPerRoom: l, wsMaxPlayersPerThread: i, getStartPosition: p }) => {
  const c = new xe({ host: r || "networking.utsubo.io", microverse: e, secure: s, debug: true, playerId: t, token: n, maxPlayersPerRoom: l || 100, maxPlayersPerThread: i || 1e3, refreshToken: o });
  return c.onConnectionStatusChange = (a) => {
    g("ping:server", { type: "multiplayer", status: a }), a === 0 && c.attempts > 1 && g("notification:server", { type: "multiplayer", action: async () => {
      c.forceReconnect();
    } }), a === 2 && g("notification:server:close", { type: "multiplayer" });
  }, M.sendCustomMessage = (a, d) => {
    c.sendCustomMessage(a, d);
  }, c.onAlreadyConnected = () => {
    console.log("connecting somewhere else, disconnected from current tab."), x({ hasConnectedElsewhere: true });
  }, c.getStartPosition(p || (() => [0, 0, 0])), c.onPlayerJoin((a, d, u) => {
    if (console.log(`Player ${a} connected to room ${u}`), a === t)
      return;
    const { playersRealtime: f } = /* @__PURE__ */ P();
    if (!f[a]) {
      const { otherPlayersStartPos: _ } = /* @__PURE__ */ P(), A = _[a] || [0, -9999, 0];
      f[a] = { prevPos: new E.Vector3(0, -9999, 0).fromArray(A), pos: new E.Vector3(0, -9999, 0).fromArray(A), quat: new E.Quaternion(), rot: new E.Euler(0, A[3], 0, "YXZ"), call: null, muted: false, deaf: false, nomic: false, noAudioChat: true, dead: false, receivedAt: 0, newReceivedAt: 0, serverDelay: 0 };
    }
    const { otherPlayers: S } = /* @__PURE__ */ P();
    S.push(a), be(a), g("player_joined", { playerId: a }), x((_) => ({ playersRealtime: f, otherPlayers: S, otherPlayersStartPos: { ..._.otherPlayersStartPos, [a]: d } }));
  }), c.onPlayerLeave((a) => {
    const { otherPlayers: d, playersRealtime: u } = /* @__PURE__ */ P();
    d.splice(d.indexOf(a), 1), u[a] && delete u[a], g("player_leave", { playerId: a }), x({ playersRealtime: u, otherPlayers: d });
  }), c.onNewPlayerData((a, d) => {
    if (a === t)
      return;
    const { playersRealtime: u } = /* @__PURE__ */ P();
    if (!u[a]) {
      const { otherPlayersStartPos: _ } = /* @__PURE__ */ P(), A = _[a] || [0, -9999, 0];
      u[a] = { prevPos: new E.Vector3(0, -9999, 0).fromArray(A), pos: new E.Vector3(0, -9999, 0).fromArray(A), quat: new E.Quaternion(), rot: new E.Euler(0, A[3], 0, "YXZ"), call: null, muted: false, deaf: false, nomic: false, noAudioChat: true, dead: false, receivedAt: 0, newReceivedAt: 0, serverDelay: 0 };
    }
    const f = u[a], S = /* @__PURE__ */ performance.now();
    f.serverDelay = S - f.newReceivedAt, f.newReceivedAt = S, f.prevPos.copy(f.pos), f.prevreceivedAt = f.newReceivedAt, d(f.pos, f.rot), f.quat.setFromEuler(f.rot);
  }), c;
}, nn = ({ localUserId: e, onChat: n, onSkin: o, onRequestPlayerData: r, onReceivePlayerData: t, onEmoji: s, onPaint: l, onPaintColor: i, onPaintSize: p, onCallStatus: c, onPlayerData: a, onDecibel: d, onAnim: u, roomId: f, token: S, refreshToken: _, animationsList: A, wshost: U, wsSecure: b, wsMaxPlayersPerRoom: F, wsMaxPlayersPerThread: j, getStartPosition: h, updateHZ: C }) => {
  const N = /* @__PURE__ */ qe(async () => {
    if (!e || e === "tempId" || !f || !U)
      return;
    const y = await en({ roomId: f, token: S, refreshToken: _, wshost: U, localUserId: e, wsSecure: b, wsMaxPlayersPerRoom: F, wsMaxPlayersPerThread: j, getStartPosition: h });
    return x({ konpiClient: y }), y;
  }, [e, f, S, U, b, F, j]), [pe, me] = /* @__PURE__ */ Q(false);
  return T(() => (N && N.connect().then(() => {
    me(true);
  }).catch((y) => {
    console.error(y);
  }), () => {
    x((y) => (y.otherPlayers.length = 0, { playersRealtime: {}, otherPlayers: y.otherPlayers })), console.log("[WebsocketManager] konpiClient disconnected"), N && N.disconnect(), me(false);
  }), [N]), T(() => {
    pe && N && (N.onLatestLatency((y) => {
      g("ping:server", { type: "multiplayer", latency: y });
    }), N.onCustomMessage((y, W, xn) => {
      const B = P().playersRealtime[y];
      if (!B)
        return;
      if (typeof W != "string") {
        a(B, y, W);
        return;
      }
      const $ = /* @__PURE__ */ W.substring(0, 1), k = /* @__PURE__ */ W.substring(1);
      if ($ === v.skin)
        o(B, y, k);
      else if ($ === v.animation) {
        if (!k) {
          console.error("no animation data", $, W);
          return;
        }
        ve(y, A, k), u(B, y, k);
      } else if ($ === v.paint)
        l(B, y, k);
      else if ($ === v.paintColor)
        i(B, y, k);
      else if ($ === v.paintSize)
        p(B, y, k);
      else if ($ === v.decibel)
        d(B, y, k);
      else if ($ === v.chat)
        n(B, y, k);
      else if ($ === v.emoji)
        s(y, k);
      else if ($ === v.callStatus)
        c(y, k);
      else if ($ === v.requestPlayerData)
        r(y);
      else if ($ === v.eventBroadcast)
        try {
          const { eventType: ne, payload: Le } = /* @__PURE__ */ JSON.parse(k);
          g(ne, Le);
        } catch (ne) {
          console.warn("WebsocketManager", "konpiClient", "invalid event broadcast", { dataExtracted: k, error: ne });
        }
      else
        $ === v.receivePlayerData ? t(y, JSON.parse(k)) : a(B, y, k);
    }));
  }, [N, pe, l, p, i, n, c, o, a, r, t]), null;
}, O = { mainProtocol: "ws" };
async function Se(e) {
  Xe(e), g(`close_call_${e.playerId}`);
}
async function tn(e, n, o) {
  Ze(e, n, o);
}
const v = { animation: "a", chat: "c", emoji: "e", paint: "f", paintSize: "z", paintColor: "y", skin: "s", eventBroadcast: "v", callStatus: "p", decibel: "d", requestPlayerData: "r", receivePlayerData: "g" };
function on(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.paint}${e}`, n) : I({ paint: e }, true);
}
function rn(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.paintSize}${e}`, n) : I({ paintSize: e }, true);
}
function sn(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.paintColor}${e}`, n) : I({ paintColor: e }, true);
}
function we(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.animation}${e}`, n) : I({ anim: e }, false);
}
function an(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.chat}${e}`, n) : I({ genchat: e });
}
function ln(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.emoji}${e}`, n) : I({ emoji: e });
}
function cn(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.skin}${JSON.stringify(e)}`, n) : I({ skin: e }, true);
}
function un(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.eventBroadcast}${JSON.stringify({ eventType: e, payload: n })}`) : I({ eventType: e, payload: n });
}
function dn(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.callStatus}${e}`, n) : I({ callStatus: e }, true);
}
function be(e) {
  const n = typeof e == "string" ? [e] : e;
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.requestPlayerData}`, n) : I({ requestPlayerData: true });
}
function fn(e, n) {
  O.mainProtocol === "ws" ? M.sendCustomMessage(`${v.receivePlayerData}${JSON.stringify(e)}`, n) : I({ receivePlayerData: e }, true);
}
function pn(e, n) {
  if (O.mainProtocol === "ws") {
    let o = "";
    for (const r in e) {
      let t;
      switch (r) {
        case "muted":
          t = "m";
          break;
        case "muteOthers":
          t = "u";
          break;
        case "camOff":
          t = "c";
          break;
        default:
          t = null;
      }
      t && (o += `${t}${e[t] ? 1 : 0};`);
    }
    o && M.sendCustomMessage(`x${o}`, n);
  } else
    I(e, true);
}
function mn(e) {
  Object.assign(O, e);
}
const gn = ({ localPlayerMesh: e, animationsList: n }) => {
  const o = e && e.userData.player, r = o && o.activAnimations;
  return T(() => {
    if (!r || !n)
      return;
    const t = {};
    Object.keys(n).forEach((l) => {
      t[n[l]] = l;
    });
    const s = { set(l, i, p) {
      l[i] = p;
      const c = /* @__PURE__ */ i.replace("_mirror", "");
      return we(t[c]), true;
    } };
    o.activAnimations = new Proxy(r, s);
  }, [o, r, n]), null;
};
function Re(e) {
  if (e.length === 0)
    return null;
  const n = /* @__PURE__ */ e.find((r) => r.deviceId === "default" || r.deviceId === "communications");
  if (n) {
    const r = /* @__PURE__ */ e.find((t) => t.groupId === n.groupId && t.deviceId !== "default" && t.deviceId !== "communications");
    if (r)
      return r.deviceId;
  }
  const o = /* @__PURE__ */ e.find((r) => r.deviceId !== "default" && r.deviceId !== "communications");
  return o ? o.deviceId : e[0].deviceId;
}
const Ae = async () => {
  const { TRTC: e } = /* @__PURE__ */ m();
  if (!e)
    return null;
  const n = await e.getMicrophoneList(), o = /* @__PURE__ */ localStorage.getItem("preferredmic");
  return n.some((t) => t.deviceId === o) ? o : Re(n);
}, Ee = async () => {
  const e = /* @__PURE__ */ localStorage.getItem("preferredvideo"), { TRTC: n } = /* @__PURE__ */ m();
  if (!n)
    return console.log("error here"), null;
  const o = await n.getCameraList();
  return o.length === 0 || o[0]?.deviceId?.length === 0 ? await P().checkDevice("video") : o.some((t) => t.deviceId === e) ? e : Re(o);
}, se = (e) => e && typeof e == "object";
function _e(e, n) {
  const o = { ...e };
  if (se(e) && se(n))
    for (const r in n)
      se(n[r]) ? r in e ? o[r] = _e(e[r], n[r]) : Object.assign(o, { [r]: n[r] }) : o[r] = n[r];
  return o;
}
const K = /* @__PURE__ */ z((e, n) => ({ client: null, peersNeedsUpdt: {}, peers: /* @__PURE__ */ new Map(), createPeer: (t, s) => {
  const { peers: l } = /* @__PURE__ */ n();
  if (l.has(t))
    return l.get(t);
  const i = { peerId: t, currentVolume: 0, isPlaying: false, enabled: { audio: false, video: false, screenShare: false } }, p = s ? _e(i, s) : i;
  return l.set(t, p), l.get(t);
}, signalPeerUpdate: (t) => {
  e((s) => {
    var _a;
    const l = { peersNeedsUpdt: s.peersNeedsUpdt };
    return (_a = l.peersNeedsUpdt)[t] ?? (_a[t] = 0), l.peersNeedsUpdt[t]++, l;
  });
} })), Te = (e, n) => K(e, n || J);
Object.assign(Te, K);
const { getState: w, setState: ke } = K, ie = async (e, n) => {
  const o = /* @__PURE__ */ w().peers.get(e);
  if (!o)
    return true;
  if (n) {
    const r = await Ee();
    if (!r)
      return console.error("No video device found"), false;
    await m().client.getVideoTrack() || await m().client.startLocalVideo({ publish: true, option: { profile: Z.RES_480P, cameraId: r } });
    const s = { publish: true, option: { profile: Z.RES_480P, cameraId: r } };
    await m().client.updateLocalVideo(s).catch((c) => (console.error("failed toggle updateLocalVideo" + c), true)), P().userMediaUpdate(false, true), o.enabled.video = true;
    const { logCall: l, meetingId: i } = /* @__PURE__ */ m(), p = /* @__PURE__ */ E.MathUtils.generateUUID();
    D({ shareCamSessionId: p }), l("shareCamera", i, p);
  } else {
    await m().client.stopLocalVideo(), o.enabled.video = false;
    const { logCall: r, meetingId: t, shareCamSessionId: s } = /* @__PURE__ */ m();
    r("stopCamera", t, s);
  }
  return w().signalPeerUpdate(getUser().id), true;
}, hn = async (e, n = true) => {
  const { client: o } = /* @__PURE__ */ m();
  return m().leavingCallPromise || (console.log("start leaveCall"), m().leavingCallPromise = new Promise((r) => {
    async function t() {
      if (m().joiningCallPromise && await m().joiningCallPromise.catch((a) => {
        console.log(a);
      }), console.log("start real leaveCall"), o === null) {
        n && D({ meetingId: null }), r();
        return;
      }
      const { peers: s } = /* @__PURE__ */ w();
      if (s.forEach((a, d) => {
        d !== e && s.delete(d);
      }), s.delete(e), o.getVideoTrack()) {
        const { logCall: a, meetingId: d, shareCamSessionId: u } = /* @__PURE__ */ m();
        a("stopCamera", d, u), await o.stopLocalVideo();
      }
      await m().stopScreenShare(), await o.exitRoom(), o.destroy(), D({ client: null });
      const { logCall: i, meetingId: p, joinCallSessionId: c } = /* @__PURE__ */ m();
      i("exitRoom", p, c), n && D({ meetingId: null }), r();
    }
    t();
  }).finally(() => {
    m().leavingCallPromise = null;
  })), await m().leavingCallPromise, true;
}, Cn = (e, n) => {
  const { signalPeerUpdate: o } = /* @__PURE__ */ w();
  n.on(e.EVENT.REMOTE_AUDIO_AVAILABLE, async ({ userId: r }) => {
    console.info(`[@utsubo/realtime] Tencent - ${r} unmute audio`);
    const t = /* @__PURE__ */ w().peers.get(r);
    t && (t.enabled.audio = true), await n.muteRemoteAudio(r, false), o(r);
  }), n.on(e.EVENT.REMOTE_AUDIO_UNAVAILABLE, async ({ userId: r }) => {
    console.info(`[@utsubo/realtime] Tencent - ${r} mute audio`);
    const t = /* @__PURE__ */ w().peers.get(r);
    t && (t.enabled.audio = false), await n.muteRemoteAudio(r, true), o(r);
  }), n.on(e.AUDIO_VOLUME, (r) => {
    r.result.forEach(({ userId: t, audioVolume: s, stream: l }) => {
      s > 10 && console.log(`[@utsubo/realtime] Tencent - user: ${t} is speaking, audioVolume: ${s}`);
      const i = /* @__PURE__ */ w().peers.get(t);
      i && (i.currentVolume = s / 100);
    });
  });
}, yn = (e, n) => {
  const { signalPeerUpdate: o } = /* @__PURE__ */ w();
  n.on(e.EVENT.REMOTE_VIDEO_AVAILABLE, async ({ userId: r, streamType: t }) => {
    console.info("[@utsubo/realtime] Tencent - remote video available", r, t);
    const s = /* @__PURE__ */ w().createPeer(r);
    if (!s) {
      console.error(`[@utsubo/realtime] Tencent - Stream not added, Peer ${r} not found`);
      return;
    }
    console.info(`[@utsubo/realtime] Tencent - remote stream added: ${r} type: ${t}`), t === "sub" ? (s.enabled.screenShare = true, g("screenshare_player_add", r)) : (s.enabled.video = true, g("video_player_add", r)), o(r);
  }), n.on(e.EVENT.REMOTE_VIDEO_UNAVAILABLE, async ({ userId: r, streamType: t }) => {
    console.info(`[@utsubo/realtime] Tencent - ${r} mute video`);
    const s = /* @__PURE__ */ w().peers.get(r);
    if (!s) {
      console.error(`[@utsubo/realtime] Tencent - Stream not added, Peer ${r} not found`);
      return;
    }
    t === "sub" ? (s.enabled.screenShare = false, g("screenshare_player_remove", r)) : s.enabled.video = false, o(r);
  });
}, Pn = (e, n) => {
  n.on(e.EVENT.REMOTE_USER_ENTER, (o) => {
    const { userId: r } = o;
    if (console.info(`[@utsubo/realtime] Tencent - peer-join ${r}`, o), !w().createPeer(r))
      return console.error(`[@utsubo/realtime] Tencent - Peer not added, id ${r} not found`), true;
    g("call_player_add", r);
  }), n.on(e.EVENT.REMOTE_USER_EXIT, async ({ userId: o }) => {
    console.info(`[@utsubo/realtime] Tencent - peer-leave ${o}`, event);
    const { peers: r } = /* @__PURE__ */ w(), t = /* @__PURE__ */ r.get(o);
    t && t.enabled.video && (await n.stopRemoteVideo({ userId: o, streamType: "main" }), t.enabled.screenShare && (await n.stopRemoteVideo({ userId: o, streamType: "sub" }), g("screenshare_player_remove", o))), r.has(o) && r.delete(o), g("call_player_remove", o);
  });
}, vn = (e, n) => {
  const { signalPeerUpdate: o } = /* @__PURE__ */ w();
  Cn(e, n), yn(e, n), Pn(e, n), n.on(e.CLIENT_BANNED, async (r) => {
    console.error(`[@utsubo/realtime] Tencent - client has been banned for ${r.reason}`), g("leaveCall"), console.info(r.reason);
  }), n.on(e.CONNECTION_STATE_CHANGED, (r) => {
  }), n.on(e.NETWORK_QUALITY, (r) => {
    const { userId: t, uplinkNetworkQuality: s, downlinkNetworkQuality: l } = r, i = /* @__PURE__ */ w().peers.get(t);
    i && (i.networkQuality === void 0 && (i.networkQuality = {}), i.networkQuality.up = s, i.networkQuality.down = l), o(t);
  });
}, Ie = async ({ meetingId: e, userId: n, trtcMode: o = "rtc", role: r = "audience", sdkAppId: t = 20002202, autoReceiveAudio: s, autoReceiveVideo: l, micEnabled: i, videoEnabled: p, reject: c }) => {
  if (m().client)
    return m().client;
  if (!m().TRTC) {
    const { default: a } = await import("trtc-sdk-v5").catch(() => (console.log("TRTC not loaded"), [null, null]));
    D({ TRTC: a }), typeof window < "u" && (window.TRTC = a), m().TRTC.setLogLevel(4);
  }
  if (m(), await Sn({ meetingId: e, userId: n, trtcMode: o, role: r, sdkAppId: t, reject: c, autoReceiveAudio: s, autoReceiveVideo: l }), m(), m().leavingCallPromise)
    throw "leaving call";
  await wn({ userId: n, micEnabled: i, videoEnabled: p });
}, Sn = async ({ meetingId: e, userId: n, trtcMode: o, role: r, sdkAppId: t, reject: s, autoReceiveAudio: l, autoReceiveVideo: i }) => {
  const { userSig: p, userSigEndpoint: c } = /* @__PURE__ */ m();
  if (!p)
    try {
      const u = await fetch(c, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ userId: n }) }), { userSig: f } = await u.json();
      D({ userSig: f, sdkAppId: t });
    } catch (u) {
      throw console.error("[@utsubo/realtime] Tencent - Failed to fetch userSig:", u), u;
    }
  const a = { scene: o, userId: n, sdkAppId: t, strRoomId: e, autoReceiveAudio: l, autoReceiveVideo: i, userSig: m().userSig };
  if (o === "live" && (a.role = r), !TRTC)
    return s();
  const d = /* @__PURE__ */ TRTC.create();
  D({ client: d }), ke({ client: d });
  try {
    await d.enterRoom(a);
  } catch (u) {
    return console.error("[@utsubo/realtime] Tencent - ", u), D({ shouldRetry: true }), s();
  }
  if (m().leavingCallPromise)
    return s();
  vn(TRTC, d);
}, wn = async ({ userId: e, micEnabled: n, videoEnabled: o }) => {
  getUser();
  const { client: r } = /* @__PURE__ */ m();
  let t = null;
  if (n) {
    const c = await Ae();
    t = await r.startLocalAudio({ option: { microphoneId: c }, publish: true });
  }
  let s = null;
  if (o) {
    const c = await Ee();
    s = await r.startLocalVideo({ publish: o, option: { profile: Z.RES_480P, cameraId: c } });
  }
  P().userMediaUpdate(true, o);
  let l = false, i;
  try {
    const c = new Promise((d, u) => {
      setTimeout(() => {
        D({ shouldRetry: true }), u(new Error("waited too long for startLocalVideo and startLocalAudio"));
      }, 1e4);
    }), a = /* @__PURE__ */ Promise.all([s, t]);
    await Promise.race([c, a]);
  } catch (c) {
    switch (c.name) {
      case "NotReadableError":
        g("notification:office", { message: "camera-mic-not-accessible" });
        break;
      default:
        l = true, g("notification:office", { message: "camera-mic-not-accessible" }), console.error(c), i = c;
        break;
    }
  }
  if (l)
    throw i;
  if (m().leavingCallPromise)
    throw "leaving call";
  const p = /* @__PURE__ */ w().createPeer(e, { enabled: { audio: n, video: o } });
  p.enabled.audio = n, p.enabled.video = o, w().signalPeerUpdate(e);
}, bn = async ({ localUserId: e, meetingId: n, trtcMode: o, role: r, autoReceiveAudio: t = true, autoReceiveVideo: s = true, videoEnabled: l, micEnabled: i }) => {
  if (!m().joiningCallPromise) {
    await m().leavingCallPromise;
    const a = new Promise((d, u) => {
      async function f() {
        const { client: S } = /* @__PURE__ */ m();
        if (!S) {
          const U = m().sdkAppId;
          try {
            await Ie({ meetingId: n, userId: e, trtcMode: o, role: r, sdkAppId: U, autoReceiveAudio: t, autoReceiveVideo: s, videoEnabled: l, micEnabled: i, reject: u });
          } catch (b) {
            return console.log("catch initTRTC"), u(b);
          }
          if (m().leavingCallPromise)
            return u();
        }
        const { logCall: _ } = /* @__PURE__ */ m(), A = /* @__PURE__ */ E.MathUtils.generateUUID();
        if (D({ joinCallSessionId: A }), _("joinCall", n, A), l) {
          const U = /* @__PURE__ */ E.MathUtils.generateUUID();
          D({ shareCamSessionId: U }), _("shareCamera", n, U);
        }
        d(true);
      }
      f();
    });
    D({ joiningCallPromise: a });
  }
  const p = await m().joiningCallPromise.catch((a) => {
    console.error(a);
  });
  D({ joiningCallPromise: null });
  const { client: c } = /* @__PURE__ */ m();
  return c.enableAudioVolumeEvaluation(300), p;
}, Ue = { RES_480P_5FPS: "480p", RES_480P_30FPS: "480p_2", RES_720P_5FPS: "720p", RES_720P_30FPS: "720p_2", RES_1080P_5FPS: "1080p", RES_1080P_30FPS: "1080p_2" }, Z = { RES_120P: "120p", RES_180P: "180p", RES_240P: "240p", RES_360P: "360p", RES_480P: "480p", RES_720P: "720p", RES_1080P: "1080p", RES_1440P: "1440p", RES_4K: "4K" }, H = /* @__PURE__ */ z((e, n) => {
  let o = null;
  X("leaveCall", () => {
    const { localUserId: c } = /* @__PURE__ */ n();
    n().leaveCall(c);
  });
  const r = async (c) => {
    const { client: a } = /* @__PURE__ */ n(), d = /* @__PURE__ */ w().peers.get(n().localUserId);
    if (d) {
      if (c) {
        const u = await Ae();
        if (!u) {
          console.error("No mic device found");
          return;
        }
        a.getAudioTrack() || await a.startLocalAudio({ publish: c, option: { microphoneId: u } }), P().userMediaUpdate(true), await a.updateLocalAudio({ mute: false, option: { microphoneId: u } }), d.enabled.audio = true;
      } else
        await a.updateLocalAudio({ mute: true }), d.enabled.audio = false, d.currentVolume = 0;
      w().signalPeerUpdate(n().localUserId);
    }
  }, t = async () => {
    const { client: c } = /* @__PURE__ */ n();
    if (!c)
      return console.error("Client is not initialized, cannot share screen!"), false;
    const a = { option: { profile: Ue.RES_720P_30FPS } };
    let d = false;
    if (await c.startScreenShare(a).catch((U) => (console.error("failed initialize localStream " + U), d = true, true)), d)
      return await s(), false;
    c.on("screen-share-stopped", async () => (console.log("screen sharing was stopped"), g("stream-canceled"), await s(), false));
    const u = n().localUserId, f = /* @__PURE__ */ w().createPeer(u);
    if (!f)
      return console.error(`Stream not added, Player ${u} not found`), true;
    f.enabled.screenShare = true;
    const { logCall: S, meetingId: _ } = /* @__PURE__ */ n(), A = /* @__PURE__ */ E.MathUtils.generateUUID();
    return e({ screenShareSessionId: A }), S("shareScreen", _, A), g("screenshare_player_add", u), true;
  }, s = async () => {
    const { client: c } = /* @__PURE__ */ n();
    c !== null && (o = new Promise((a) => {
      async function d() {
        const { localUserId: u } = /* @__PURE__ */ n();
        await c.stopScreenShare().catch((U) => {
          console.error("Failed to stop screen share", U);
        });
        const f = /* @__PURE__ */ w().createPeer(u);
        if (!f) {
          console.error(`Stream not added, Player ${u} not found`);
          return;
        }
        f.enabled.screenShare = false, g("screenshare_player_remove", u);
        const { logCall: S, meetingId: _, screenShareSessionId: A } = /* @__PURE__ */ n();
        S("stopShareScreen", _, A), a();
      }
      d();
    }), await o);
  };
  return { localUserId: null, client: null, TRTC: null, joiningCallPromise: null, leavingCallPromise: null, isJoiningCall: false, userSigEndpoint: null, startScreenShare: t, stopScreenShare: s, startWebcam: async () => w().peers.get(n().localUserId) && !await ie(n().localUserId, true) ? false : (g("setSettings", { privacy: { videoEnabled: true } }), true), stopWebcam: async () => {
    w().peers.get(n().localUserId) && await ie(n().localUserId, false), g("setSettings", { privacy: { videoEnabled: false, trackingEnabled: false } });
  }, setMutedState: r, toggleVideoCall: ie, initTRTC: Ie, joinCall: bn, leaveCall: hn, changeDevice: async (c, a, d) => {
    const { client: u } = /* @__PURE__ */ n();
    let f = null;
    switch (a) {
      case "audioinput":
        f = "audio";
        break;
      case "videoinput":
        f = "video";
        break;
      default:
        f = null;
        break;
    }
    if (f && d) {
      if (f === "video" && !u.getVideoTrack()) {
        console.log("Video track does not exist, cannot switch device");
        return;
      }
      f === "audio" ? await u.updateLocalAudio({ option: { microphoneId: d } }) : f === "video" && await u.updateLocalVideo({ option: { cameraId: d } });
    }
  }, sdkAppId: 20002202, cameraId: null, microphoneId: null };
}), De = (e, n) => H(e, n || J);
Object.assign(De, H);
const { getState: m, setState: D } = H, ae = /* @__PURE__ */ z((e, n) => ({ mainUserId: null, peerId: null, peer: null, connections: [], connectionsByPlayerId: {}, data: [], setPeer: (o, r) => e({ mainUserId: o, peer: r }), addConnection: (o, r) => e((t) => ({ connections: [...t.connections, r], connectionsByPlayerId: { ...t.connectionsByPlayerId, [o]: r } })), removeConnection: (o, r) => e((t) => {
  const s = { ...t.connectionsByPlayerId };
  return delete s[o], { connections: t.connections.filter((l) => l !== r), connectionsByPlayerId: s };
}), connectToPeer: (o, r) => {
  const t = /* @__PURE__ */ n();
  if (!t.peer || !t.peer.open) {
    console.error("Peer is not ready");
    return;
  }
  if (t.connections.some((l) => l.peer === r)) {
    console.error("Already connected to this peer");
    return;
  }
  const s = /* @__PURE__ */ t.peer.connect(r, { metadata: { playerId: t.mainUserId, peerId: t.peerId }, serialization: "json" });
  s.on("open", () => {
    t.addConnection(o, s), s.on("close", () => {
      t.removeConnection(o, s);
    });
  });
}, disconnectFromPeer: (o) => {
  const r = /* @__PURE__ */ n(), t = r.connectionsByPlayerId[o];
  if (!t) {
    console.log("Not connected to this peer");
    return;
  }
  t.close(), r.removeConnection(o, t);
} })), le = (e, n) => ae(e, n || J);
Object.assign(le, ae);
const { getState: ee, setState: $e } = ae, Me = { host: "sougen-peerjs.uc.r.appspot.com", iceServers: [] }, Rn = () => {
  console.warn("open should remove existing co");
  for (let e = 0; e < R.length; e++)
    Oe(R[e], R[e].playerId);
};
let ce;
function An() {
  !ye("isFirefox") && !ye("isIOS") && URL.revokeObjectURL(URL.createObjectURL(new Blob([new ArrayBuffer(5e7)])));
}
const En = async () => {
  let e = V().peer;
  if (e) {
    P().onPeerIdChange(e._id);
    return;
  }
  X("remove_player", (r) => {
    de(r);
  }), ce && clearInterval(ce), ce = setInterval(An, 1e4);
  let n;
  try {
    n = await fetch("/api/ice?otp=" + Math.random().toString(20).substring(2, 12), { method: "GET" }), n = await n.json();
  } catch (r) {
    console.error("couldnt retrieve ices datas", r), n = false;
  }
  if (!n || n.error)
    return false;
  Me.iceServers = n.urls.map((r) => ({ urls: r, username: n.username, credential: n.credential }));
  const o = new ze(null, { config: Me, host: "sougen-peerjs.uc.r.appspot.com", path: "/", secure: true, key: "peerjs" });
  Qe({ peer: o }), o.on("error", (r) => {
    const t = /* @__PURE__ */ r.toString().replace("Error: Could not connect to peer ", ""), s = /* @__PURE__ */ Ye(t);
    s || console.warn("didnt find errorPeer PeerId =" + t), P().onPeerConnectError(r, s);
  }), o.on("disconnected", () => {
    const r = /* @__PURE__ */ setInterval(() => {
      o.disconnected ? o.reconnect() : clearInterval(r);
    }, 1e4);
    o.reconnect();
  }), o.on("open", (r) => {
    Rn(), P().onPeerIdChange(o._id), o.on("connection", (t) => {
      ue(t, t.metadata.playerId, t.metadata.peerId);
    }), P().onInitWebrtc(), o.on("close", (t) => {
      P().onCloseWebrtc();
    }), o.on("call", (t) => {
      const s = /* @__PURE__ */ Ge(t.metadata.playerId);
      s && (s.call = t), Tn(t, t.metadata.playerId);
    });
  });
}, _n = (e, n) => {
  const o = { reliableConn: null, conn: null, playerId: e, peerId: n, unavailableCnt: 0 };
  return R.push(o), o;
}, ue = (e, n, o) => {
  window.peersConn = R;
  let r = null, t = null;
  return e.on("error", (s) => {
    console.warn(s.type, s);
  }), e.on("close", (s) => {
    g(`peerClosed_${n}`);
  }), r = R.find((s) => s.playerId === n), r ? (t = r, t.unavailableCnt = 0) : t = _n(n, o), V().addPeerConnsByIds(n, t), e.reliable ? (t.reliableConn && t.reliableConn.close(), t.reliableConn = e, e.open ? (V().addReliableConn(n, e), g(`connReliable_ready_${n}`), g("peersOpenCountChanged")) : e.on("open", () => {
    V().addReliableConn(n, e), g(`connReliable_ready_${n}`), g("peersOpenCountChanged");
  })) : (t.conn && t.conn.close(), t.conn = e, e.open ? (V().addConn(n, e), g(`conn_ready_${n}`), g("peersOpenCountChanged")) : e.on("open", () => {
    V().addConn(n, e), g(`conn_ready_${n}`), g("peersOpenCountChanged");
  })), t.conn && t.reliableConn && (g(`peer_ready_${n}`, t), g("peersCountChanged", R.length)), t;
}, de = (e) => {
  const n = [];
  for (let o = R.length - 1; o >= 0; o--) {
    const r = R[o];
    r.playerId === e && (R.splice(o, 1), n.push(r));
  }
  return V().removeReliableConn(e), V().removeConn(e), V().removePeerConnsByIds(e), n.length <= 0 ? false : (Oe(n[0]), g("peersCountChanged", R.length), true);
}, Oe = (e, n) => {
  e.conn && (e.conn.close(), e.conn = null), e.reliableConn && (e.reliableConn.close(), e.reliableConn = null), e.call && (e.call.close(), e.call = null), e = null;
};
async function Tn(e, n) {
  let o = await P().getAudioStream();
  e.answer(o), e.on("stream", (r) => {
    g(`stream_start_${n}`, r);
  });
}
const kn = (e) => {
  const [n, o] = /* @__PURE__ */ Q(null), r = /* @__PURE__ */ L((t) => t.getPeerPeerId);
  return T(() => {
    if (n)
      return;
    const t = /* @__PURE__ */ r(e, (s) => o(s));
    return () => {
      t && t();
    };
  }, [n, r, e]), T(() => () => {
    o(null);
  }, []), [n, o];
}, In = (e, n, o, r) => {
  const t = /* @__PURE__ */ oe((u) => u.peerConnsByIds[o]), [s, l] = /* @__PURE__ */ Q(false), [i, p] = /* @__PURE__ */ Q(false), [c, a] = /* @__PURE__ */ Q(false), d = /* @__PURE__ */ je(() => {
    l(null), p(null), a(!c), de(o), r(null);
  }, [o, c, r]);
  return ge(`peerClosed_${o}`, () => {
    t && d();
  }), T(() => {
    if (n && t && t.peerId && t.peerId !== n) {
      d();
      return;
    }
    if (e && n && !t) {
      const u = P().playerId;
      if (u > o)
        return;
      let f = e.connect(n, { metadata: { playerId: u, peerId: e.id }, serialization: "json" });
      f && ue(f, o, n);
      let S = e.connect(n, { metadata: { playerId: u, peerId: e.id }, reliable: true, serialization: "json" });
      S && ue(S, o, n);
    }
  }, [e, o, n, t, c]), T(() => (!t || !t.conn || !t.conn.open ? X(`conn_ready_${o}`, () => {
    l(true);
  }, { once: true }) : t.conn.open && !s && l(true), () => {
    he(`conn_ready_${o}`);
  }), [s, t, o]), T(() => (!t || !t.reliableConn || !t.reliableConn.open ? X(`connReliable_ready_${o}`, () => {
    p(true);
  }, { once: true }) : t.reliableConn.open && !i && p(true), () => {
    he(`connReliable_ready_${o}`);
  }), [i, t, o]), T(() => {
    let u;
    const f = P().playerId;
    return t && f < o && t.unavailableCnt < 3 && (u = setInterval(() => {
      (!t || !t.conn || !t.conn.open || !t.reliableConn || !t.reliableConn.open) && (t.unavailableCnt >= 3 || d(), clearInterval(u));
    }, 1e4)), () => {
      clearInterval(u);
    };
  }, [t, s, i]), T(() => () => {
    d();
  }, []), i && s && t ? t : null;
}, Un = (e, n) => {
  const [o, r] = /* @__PURE__ */ kn(n);
  return In(e, o, n, r);
}, Dn = (e, n, o, r, t) => {
  let s = false;
  if (o === "closeCall")
    Se(n), s = true;
  else if (o === "readyToReceive")
    r(n), e.send("sentInitPeerData"), s = true;
  else if (o === "sentInitPeerData")
    n.sentInitialPeerInfos || r(n), s = true;
  else if (o.t) {
    const l = performance.timeOrigin + performance.now();
    n.peerTimeOffsetWhenReceived = l - parseFloat(o.t);
    let i = 0, p = 0;
    for (let c = 0; c < R.length; c++)
      R[c].peerTimeOffsetWhenReceived && (i += l - R[c].peerTimeOffsetWhenReceived, p++);
    if (i += l, p++, p !== 0) {
      const c = i / p;
      t(c - l);
    }
    s = true;
  }
  return s;
}, $n = ({ localUserId: e, peerConns: n, playerId: o }) => {
  const { conn: r, reliableConn: t } = n, [s, l, i, p, c, a, d, u, f, S, _, A, U] = /* @__PURE__ */ L((h) => [h.onAnim, h.onPaint, h.onPaintColor, h.onPaintSize, h.onDecibel, h.onTransform, h.onChat, h.onSkin, h.onEmoji, h.onPlayerData, h.sendInitData, h.onTimeSync, h.animationsList]), b = /* @__PURE__ */ L((h) => h.playersRealtime[o]), F = /* @__PURE__ */ L((h) => h.playersRealtime[e]);
  T(() => {
    if (!r || !player || !h)
      return;
    function h(C) {
      C.anim ? (ve(o, U, C.anim), s(b, o, C)) : C.decibel ? c(b, o, C) : C.emoji ? f(b, o, C) : C.paint ? l(b, o, C) : a(b, o, C);
    }
    return r.on("data", h), () => {
      r.off("data", h);
    };
  }, [r, b, s, l, f, c, a]), T(() => () => {
    de(o), player && (player.sentInitialPeerInfos = false);
  }, []), T(() => {
    if (!t || !b || !h)
      return;
    function h(C) {
      Dn(t, b, C, _, A) || (C.genchat ? d(b, o, C) : C.skin ? u(b, o, C) : C.paint ? l(b, o, C) : C.paintColor ? i(b, o, C) : C.paintSize ? p(b, o, C) : C.emoji ? f(b, o, C) : S(b, o, C));
    }
    return t.on("data", h), t.send("readyToReceive"), () => {
      t.off("data", h);
    };
  }, [t, b, d, f, l, i, p, u, S, _]);
  let j = 0;
  G(() => {
    j === 9 && b.call && t.open && !F.muted && t.send({ decibel: F.decibel }), j++, j = j % 10;
  });
}, Mn = ({ localUserId: e, localPeer: n, playerId: o }) => {
  const r = /* @__PURE__ */ Un(n, o);
  return r ? Ce($n, { peerConns: r, playerId: o }) : null;
}, q = [], On = 1 / 30, Y = new E.Vector3(), fe = new E.Vector3(), Ve = new E.Vector3(), Vn = ({ localUserId: e }) => {
  const [n] = /* @__PURE__ */ oe((i) => [i.peer]), [o, r] = /* @__PURE__ */ L((i) => [i.otherPlayers, i.otherPlayers.length]), t = /* @__PURE__ */ Fe((i) => i.currentPlayer), { halfCapsule: s } = /* @__PURE__ */ We();
  window.getPeersStore = V, T(() => {
    En();
  }, []), T(() => {
    let i = setInterval(() => {
      let p = performance.timeOrigin + performance.now();
      I({ t: p });
    }, 1e4);
    return () => {
      i && clearInterval(i);
    };
  }, []);
  let l = 0;
  return G(function(p, c) {
    if (l += c, !(l < On || !t)) {
      l = 0, t.position.toArray(q), t.quaternion.toArray(q, 3);
      for (let a = 0; a < q.length; a++)
        q[a] = q[a].toFixed(2);
      I(q, false);
    }
  }, 999), ge("peerSendReliable", (i) => {
    I(i);
  }), G(function(p, c) {
    const a = P().playersRealtime;
    for (const d in a) {
      const u = a[d];
      if (!u)
        return;
      const f = u.mesh;
      if (!f)
        return;
      if (isNaN(u.pos.x) || isNaN(u.prevPos.x))
        continue;
      fe.copy(u.pos).sub(u.prevPos), Ve.copy(u.pos).add(fe);
      const S = /* @__PURE__ */ fe.length();
      S > 100 || S === 0 ? (f.position.copy(u.pos), f.quaternion.copy(u.quat)) : (f.position.damp(Ve, 10, c), f.quaternion.damp(u.quat, 6.5, c)), Y.set(0, s, 0), Y.applyQuaternion(f.quaternion), f.peerKinematicApi.positionx = f.position.x - Y.x, f.peerKinematicApi.positiony = f.position.y - Y.y, f.peerKinematicApi.positionz = f.position.z - Y.z;
    }
  }, Pe.renderPriority.updateAllPositions), n && o.map((i, p) => Ce(Mn, { localUserId: e, localPeer: n, playerId: i }, i));
}, Nn = async (e) => {
  const { setPeer: n } = /* @__PURE__ */ ee(), o = { host: "sougen-peerjs.uc.r.appspot.com", iceServers: [] };
  let r = null;
  try {
    r = await fetch("/api/ice", { method: "GET" }), r = await r.json();
  } catch (s) {
    console.error("couldnt retrieve ices datas", s), r = false;
  }
  let t = null;
  return r && r.iceServers ? (o.iceServers = r.iceServers.urls.map((s) => ({ urls: s, username: r.iceServers.username, credential: r.iceServers.credential })), t = new Je({ config: o, host: "sougen-peerjs.uc.r.appspot.com", path: "/", secure: true, key: "peerjs" })) : t = null, n(e, t), t;
};
function Bn({ localUserId: e, sharePeerId: n }) {
  const { setPeer: o, addConnection: r, removeConnection: t } = /* @__PURE__ */ ee(), s = /* @__PURE__ */ le((l) => l.peer);
  return T(() => e === "tempId" ? void 0 : ((async () => {
    Nn(e);
  })(), () => {
    const { peer: i } = /* @__PURE__ */ ee();
    i && i.destroy(), o(null);
  }), [e]), T(() => {
    s && s.on("open", (l) => {
      $e({ peerId: l }), n(l).then((i) => {
      }), s.on("connection", (i) => {
        r(i.metadata.playerId, i), i.on("close", () => {
          t(i.metadata.playerId, i);
        });
      });
    });
  }, [s]), null;
}
const Ln = new E.Vector3(), Ne = new E.Vector3(), Be = new E.Vector3(), jn = ({ localUserId: e, playersMeshes: n, updateHZ: o }) => {
  const r = /* @__PURE__ */ L((s) => s.konpiClient);
  let t = 0;
  return G(function(l, i) {
    if (!r)
      return;
    t += i;
    const p = n[e];
    t < o || !p || (t -= o, p.rotation.order !== "YXZ" && (p.rotation.order = "YXZ"), r.sendPlayerData(p.position, p.rotation));
  }, 999), G(function(l, i) {
    const p = P().playersRealtime;
    for (const c in p) {
      const a = p[c];
      if (!a)
        return;
      const d = a.mesh;
      if (!d)
        return;
      if (isNaN(a.pos.x) || isNaN(a.prevPos.x))
        continue;
      Ne.copy(a.pos).sub(a.prevPos), Be.copy(a.pos);
      const u = /* @__PURE__ */ Ne.length();
      u > 20 || u === 0 ? (d.position.copy(a.pos), d.quaternion.copy(a.quat)) : (d.position.damp(Be, 10, i), d.quaternion.damp(a.quat, 6.5, i)), d.position.copy(d.position), d.quaternion.damp(a.quat, 6.5, i), Ln.applyQuaternion(d.quaternion), d.updateMatrix(), d.matrixWorldNeedsUpdate = false, d.matrixWorld.copy(d.matrix);
      const f = /* @__PURE__ */ d.api.getParent();
      f.current && f.current.setMatrixAt(d.userData.id, d.matrix);
    }
  }, Pe.renderPriority.updateAllPositions), null;
};
export {
  Z as LOCALVIDEO_PROFILE_QUALITY,
  Bn as PeerJSClient,
  gn as PlayerSyncWithPeers,
  v as RealtimeAPIPrefix,
  jn as RealtimeUpdatePeersMatrix,
  Ue as SCREENSHARE_PROFILE_QUALITY,
  Vn as WebRTCManager,
  nn as WebSocketManager,
  Se as closeCall,
  P as getRealtime,
  ee as getStorePeerJs,
  w as getStorePeers,
  m as getStoreTencent,
  be as requestPlayerData,
  we as sendAnim,
  an as sendChat,
  ln as sendEmoji,
  un as sendEventBroadcast,
  on as sendPaint,
  sn as sendPaintColor,
  rn as sendPaintSize,
  pn as sendPlayerData,
  fn as sendRequestedPlayerData,
  cn as sendSkin,
  dn as setCallStatus,
  x as setRealtime,
  mn as setRealtimeConf,
  $e as setStorePeerJs,
  ke as setStorePeers,
  D as setStoreTencent,
  tn as startAudioChat,
  L as useRealtime,
  le as useStorePeerJs,
  Te as useStorePeers,
  K as useStorePeersImpl,
  De as useStoreTencent,
  H as useStoreTencentImpl
};
